// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2SGaA","row":"Node_row__3JfwY","label":"Node_label__2AZDM","footer":"Node_footer__EZQLd"};